import React from 'react';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import cn from 'classnames';

export const PrintIcon = ({ className, accessibility = {} }) => (
  <Icon
    id="print"
    width="16"
    height="16"
    className={cn('align-middle', className)}
    accessibility={{
      ariaLabel: 'Print',
      ...accessibility,
    }}
  />
);
